module.exports = __webpack_public_path__ + "img/settings-interface-gbwsap.0dbeaa1d.webp";